/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ApplePayConnectorLoader Input Action
 */
export class ApplePayConnectorLoaderInput implements Msdyn365.IActionInput {
    constructor() {}
    public getCacheKey = () => `ApplePayConnectorLoader`;
    public getCacheObjectType = () => 'ApplePayConnectorLoader';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IApplePayConnectorLoaderData {
    applepPayConnectorLoading: boolean; // applepay
}


const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ApplePayConnectorLoaderInput();
};

async function action(input: ApplePayConnectorLoaderInput, ctx: Msdyn365.IActionContext): Promise<IApplePayConnectorLoaderData> {
    return { applepPayConnectorLoading: true };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IApplePayConnectorLoaderData>>action,
    id: 'ApplePayConnectorLoader',
    input: createInput
});
